import React from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';
import { KPISelector } from '../../atoms/KPISelector';
import { KPIOption } from 'src/features/Settings/types';

type KPIModel = {
  id: string;
  kpiSource: string;
  kpiMetric: string;
  kpiCategory: string;
};

type KPIConfigurationProps = {
  model: KPIModel;
  onCategoryChange: (modelId: string, value: string) => void;
  onCategoryReset: (modelId: string) => void;
  onSourceChange: (modelId: string, value: string) => Promise<void>;
  onSourceReset: (modelId: string) => void;
  onMetricChange: (modelId: string, value: string) => void;
  onMetricReset: (modelId: string) => void;
  kpiSources: KPIOption[];
  kpiMetrics: KPIOption[];
  kpiCategories: KPIOption[];
  isLoading: boolean;
};

export const KPIConfiguration: React.FC<KPIConfigurationProps> = ({
  model,
  onSourceChange,
  onSourceReset,
  onMetricChange,
  onMetricReset,
  onCategoryChange,
  onCategoryReset,
  kpiSources,
  kpiMetrics,
  kpiCategories,
  isLoading,
}) => {
  return (
    <Box
      border="1px solid"
      borderColor="border.layout"
      borderRadius="24px"
      p={6}
      bg="surface.card">
      <Text fontSize="16px" fontWeight={600} color="text.title" mb={6}>
        KPI
      </Text>

      <Flex direction={{ base: 'column', lg: 'row' }} gap={4}>
        {/* Source Selector */}
        <KPISelector
          label="Source"
          value={model.kpiSource}
          onChange={(value) => onSourceChange(model.id, value)}
          onReset={() => onSourceReset(model.id)}
          options={kpiSources}
          placeholder="Select source"
          disabled={false}
          isLoading={isLoading}
        />

        {/* Metric Selector */}
        <KPISelector
          label="Metric"
          value={model.kpiMetric}
          onChange={(value) => onMetricChange(model.id, value)}
          onReset={() => onMetricReset(model.id)}
          options={kpiMetrics}
          placeholder="Select metric"
          disabled={!model.kpiSource || isLoading}
          isLoading={isLoading}
        />

        {/* Category Selector */}
        <KPISelector
          label="Category"
          value={model.kpiCategory}
          onChange={(value) => onCategoryChange(model.id, value)}
          onReset={() => onCategoryReset(model.id)}
          options={kpiCategories}
          placeholder="Select category"
          disabled={!model.kpiSource || isLoading || kpiCategories.length === 0}
          isLoading={isLoading}
        />
      </Flex>
    </Box>
  );
};
